import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

import "./Dashboard.css";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [locked, setLocked] = useState(false);

  const handleInactive = () => {
    setLocked(true);

    setTimeout(() => {
      import("sweetalert2").then((Swal) => {
        Swal.default.fire({
          title: "Account Locked 🔐",
          html: `
            <div style="font-size:16px;">
              Your account is currently <b style="color:#ff3b3b">Inactive</b>.<br/>
              Please contact admin to enable your services.<br/><br/>
              अपना account एक्टिव करने के लिए Whatsapp करे।<br/><br/>

              <div style="
                padding:12px;
                background:#0e1a44;
                border-radius:10px;
                border: 1px solid rgba(255,255,255,0.2);
              ">
                📞 <b>Support:</b> +91 7303554199 <br/>

                <a 
                  href="https://wa.me/7303554199?text=Hello%20Admin,%20please%20activate%20my%20account."
                  target="_blank"
                  style="
                    display:inline-block;
                    margin-top:10px;
                    background:#25D366;
                    color:white;
                    padding:8px 14px;
                    border-radius:25px;
                    text-decoration:none;
                    font-weight:600;
                  "
                >
                  💬 Chat on WhatsApp
                </a>
              </div>
            </div>
          `,
          iconHtml: "🔒",
          background: "linear-gradient(135deg,#0b1220,#000)",
          color: "#fff",
          confirmButtonText: "Contact Admin",
          confirmButtonColor: "#ff004c",
          allowOutsideClick: false,
          width: 420,
          timer: 20000,
          timerProgressBar: true
        }).then(() => navigate("/contact"));
      });
    }, 1500);
  };

  // LOAD USER SAFE
  useEffect(() => {
    let storedUser = null;

    try {
      storedUser = JSON.parse(localStorage.getItem("user"));
    } catch {
      localStorage.removeItem("user");
      navigate("/");
      return;
    }

    if (!storedUser) {
      navigate("/");
    } else {
      setUser(storedUser);
      if (storedUser.status == 0) handleInactive();
    }
  }, [navigate]);



  // =========================
  //  AUTO REFRESH + WALLET INSTANT UPDATE
  // =========================
  useEffect(() => {
    const refreshUser = async () => {
      try {
        const stored = localStorage.getItem("user");
        if (!stored) return;

        let parsedUser = null;
        try {
          parsedUser = JSON.parse(stored);
        } catch {
          localStorage.removeItem("user");
          navigate("/");
          return;
        }

        // 🔥 Force Fresh (no cache EVER)
        const res = await fetch(
          `https://rcfinder.online/api/get_user.php?id=${parsedUser.id}&t=${Date.now()}`,
          { cache: "no-store" }
        );

        const text = await res.text();

        if (!text || text[0] !== "{") {
          console.log("❌ INVALID RESPONSE =>", text);
          return;
        }

        let data = null;
        try {
          data = JSON.parse(text);
        } catch {
          console.log("❌ JSON Parse Failed =>", text);
          return;
        }

        const userData = data.user || data.data || null;

        if (data.status && userData) {
          setUser(userData);
          localStorage.setItem("user", JSON.stringify(userData));

          if (userData.status == 0) handleInactive();
        }

      } catch (err) {
        console.log("USER REFRESH FAILED", err);
      }
    };

    refreshUser();

    // Refresh when user returns to tab
    window.addEventListener("focus", refreshUser);

    // 🔥 Trigger after ANY service updates wallet
    window.addEventListener("walletUpdated", refreshUser);

    // Background refresh every 30s
    const t = setInterval(refreshUser, 30000);

    return () => {
      window.removeEventListener("focus", refreshUser);
      window.removeEventListener("walletUpdated", refreshUser);
      clearInterval(t);
    };
  }, [navigate]);



  if (!user) return <div>Loading...</div>;


  return (
    <div className="dashboard-container">

      {locked && (
        <div className="lock-overlay">
          <div className="lock-box">
            🔐
            <p>Account Locked</p>
          </div>
        </div>
      )}

      <div className={isSidebarOpen ? "sidebar-area" : "sidebar-area closed"}>
        <Sidebar user={user} />
      </div>

      <div className={`main-area ${isSidebarOpen ? "" : "full-width"}`}>
        <Header
          user={user}
          toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          isSidebarOpen={isSidebarOpen}
        />

        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default DashboardLayout;
